import { createTheme } from "../theme.js";
import { useStorageItemValue } from "./context.js";
import * as React from "react";
import { useMemo } from "react";
export function ThemeProvider({ storageKey = "theme", defaultTheme, children }) {
    const storageTheme = useStorageItemValue(storageKey);
    const theme = useMemo(() => createTheme({
        ...defaultTheme,
        ...storageTheme,
    }), [defaultTheme, storageTheme]);
    return (React.createElement("div", { className: theme }, children));
}
//# sourceMappingURL=theme.js.map